module.exports = __webpack_public_path__ + "static/img/flow.ee3be858.jpg";